import * as React from 'react';

import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CancelIcon from '@mui/icons-material/Cancel';
import { styled } from '@mui/material';


const FailureIcon = styled(CancelIcon)({
    color: 'red',
});

const SuccessIcon = styled(CheckBoxIcon)({
    color: 'green',
});

export const SuccessFailureIndicator = ({success}: {success: boolean}) => success?<SuccessIcon />:<FailureIcon />
